import ReactDOM from 'react-dom'
import { WebForm } from 'apps/web-forms'

import 'apps/web-forms/styles/styles.scss'
const hasWhiteLabels = document.querySelector('#web-form-container').dataset.hasWhiteLabels;
ReactDOM.render(<WebForm hasWhiteLabels={hasWhiteLabels}/>, document.querySelector('#web-form-container'))